/**
 * Viewport breakpoints shared across the app.
 *
 * The mobile breakpoint mirrors `$breakpoint-mobile` in
 * `src/styles/_variables.scss` — keep the two in sync. SCSS media queries and
 * JS `matchMedia` cannot share a single literal, so this is the canonical
 * value for JS-side logic (see `useIsMobile`).
 */
export const MOBILE_MAX_WIDTH_PX = 768

/** The mobile viewport as a `matchMedia` query string. */
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH_PX}px)`
